module.exports = __webpack_public_path__ + "img/pyramid.dc7cf1aa.jpeg";